import { EnergyTotals, fmtKwh } from '../lib/history'

/** Energy for the visible range, kWh to one decimal place. */
export function EnergySummary({ totals }: { totals: EnergyTotals }) {
  const items: [string, number][] = [
    ['Imported', totals.imported],
    ['Exported', totals.exported],
    ['Battery charged', totals.charged],
    ['Battery discharged', totals.discharged],
    ['Home used', totals.used],
  ]
  return (
    <dl className="history-energy">
      {items.map(([label, v]) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{fmtKwh(v)}<small> kWh</small></dd>
        </div>
      ))}
    </dl>
  )
}
